import { useMutation } from '@apollo/client';

import UpdateInjectableActivityProgressDocument from 'bundles/ondemand-common/activity-injection/queries/UpdateInjectableActivityProgress.graphql';
import type {
  UpdateInjectableActivityProgressMutation,
  UpdateInjectableActivityProgressMutationVariables,
} from 'bundles/ondemand-common/activity-injection/queries/__generated__/UpdateInjectableActivityProgress';

/**
 * Hook to run the UpdateInjectableActivityProgress GraphQL mutation.
 */
export const useUpdateActivityProgress = () => {
  const [mutate, { loading, error }] = useMutation<
    UpdateInjectableActivityProgressMutation,
    UpdateInjectableActivityProgressMutationVariables
  >(UpdateInjectableActivityProgressDocument, {
    context: { clientName: 'gatewayGql' },
  });

  // error handling is done in the caller to allow for optimistic updates and
  // rollbacks.
  const updateActivityProgress = (input: UpdateInjectableActivityProgressMutationVariables['input']) =>
    mutate({ variables: { input } });

  return { updateActivityProgress, loading, error };
};
